export default __webpack_public_path__ + "static/media/btn_song_recording.88f695f6.png";